/**
 * Loads language/locale scripts dynamically
 * Separated to unit test better and keep the path
 * as hardcoded as possible.
 *
 */
class L10nScriptLoaderService {

  public getLocalizeMessages(localeName: string): Promise <void> {
    return this.loadScript(`localize/messages.${localeName}.js?${BuildId}`);
  }

  public getLocalizeFormattersAndParsers(localeName: string): Promise <void> {
    return this.loadScript(`localize/formatters-and-parsers.${localeName}.js?${BuildId}`);
  }

  private loadScript(srcUrl: string): Promise<any> {
    const scriptTag: HTMLScriptElement = document.createElement('script');
    document.body.appendChild(scriptTag);
    const promise = new Promise((resolve, reject) => {
      scriptTag.onload = resolve;
      scriptTag.onerror = reject;
    });
    scriptTag.src = srcUrl;

    return promise;
  }
}

export const L10nScriptLoader = new L10nScriptLoaderService();
